<template>
  <div
    v-if="state.isOpen"
    class="StellaModal z-40 flex flex-col items-center justify-end md:justify-center"
    :class="[state.config.type === 'modal' && 'fixed inset-0']"
  >
    <div
      :class="
        state.config.type === 'modal' &&
        'bg-navy-90 opacity-50 absolute inset-0'
      "
      @click.self="maybeClose()"
    />

    <component :is="state.component" v-bind="state.componentProps" />
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted } from 'vue'
import { stellaModal, _useStellaModalState } from '.'

const state = _useStellaModalState()

function maybeClose() {
  if (state.config.strict) return
  stellaModal.close()
}

function onKeyupHandler(e: KeyboardEvent) {
  if (e.key === 'Escape') maybeClose()
}

onMounted(() => {
  window.addEventListener('keyup', onKeyupHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('keyup', onKeyupHandler)
})
</script>

<style lang="scss" scoped></style>
